、<template>
  <nav-bar title="用户" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <UserMap
      v-if="!isLoading && !showLoading"
      :point="point"
      :title="userInfo.companyName"
    />
    <van-cell-group class="group" title="">
      <van-cell title="订单" :to="`/orderListById/${userId}`" is-link />
      <van-cell title="钢瓶" :to="`/customerCylinderById/${userId}`" is-link />
    </van-cell-group>
    <van-cell-group class="group" title="基本信息">
      <van-cell title="风险分析" value="无" />
      <van-cell title="用户名" :value="userInfo.companyName" />
      <van-cell title="用户名代码" :value="userInfo.creditNo || '暂无'" />
      <van-cell title="联系人" :value="userInfo.userName" />
      <van-cell title="联系电话" :value="userInfo.phoneNum" />
      <van-cell title="街道" :value="userInfo.streetName || '暂无'" />
      <van-cell title="地址" :value="userInfo.address" />
      <van-cell title="供应商名称" :value="userInfo.supplyName" />
      <van-cell title="经办人" :value="userInfo.handlerName" />
      <van-cell title="经办人电话" :value="userInfo.handlerTel" />
      <van-cell title="上次送货人" :value="userInfo.deliveryName" />
      <van-cell title="上次送货人电话" :value="userInfo.deliveryTel" />
      <van-cell title="上次送货车辆" :value="userInfo.carInfo" />
      <van-cell
        title="合同照片"
        is-link
        v-if="userInfo.imgList && userInfo.imgList.length"
        @click="showPopup(userInfo.imgList)"
      />
    </van-cell-group>
    <div class="line-container" ref="line"></div>
  </Content>
  <Popup title="合同照片" ref="popup" minHeight="100%">
    <img v-for="(item, index) in userInfo.imgList" :src="item" :key="index">
  </Popup>
</template>

<script>
import { ImagePreview } from 'vant'
import { bGlmCustomer, getCustomerStat } from '@/api/user'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { reactive, ref, onMounted } from 'vue'
// import { useStore } from 'vuex'
import { useGetData } from '@/hooks/useGetData'
import * as echarts from 'echarts'
export default {
  name: 'UserInfo',
  props: ['userId'],
  setup(props) {
    const userInfo = ref({})
    const point = reactive({
      longitude: '',
      latitude: ''
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      bGlmCustomer,
      data => {
        userInfo.value = data
        point.longitude = data.longitude
        point.latitude = data.latitude
      },
      props.userId
    )
    getDataLoading()

    // const store = useStore()
    // const companyId = computed(() => store.state.roleInfo.companyId)
    // console.log(companyId)
    const line = ref(null)
    const xAxis = ref([])
    const yMonAvg = ref([])
    const yYearAvg = ref([])
    const yDayAvg = ref([])
    onMounted(() => {
      const chart = echarts.init(line.value)
      const getCompanyInfo = useGetData(getCustomerStat, data => {
        xAxis.value = data.xaxis
        yDayAvg.value = data.ydayAvg
        yMonAvg.value = data.ymonAvg
        yYearAvg.value = data.yyearAvg
        chart.setOption({
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {},
          grid: {
            left: '10%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxis.value
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '日均使用量',
              type: 'line',
              stack: 'Total',
              data: yDayAvg.value
            },
            {
              name: '30日均使用量',
              type: 'line',
              stack: 'Total',
              data: yMonAvg.value
            },
            {
              name: '年均使用量',
              type: 'line',
              stack: 'Total',
              data: yYearAvg.value
            }
          ]
        })
      })
      getCompanyInfo(props.userId)
    })
    const popup = ref(null)
    const showPopup = (list) => {
      ImagePreview(list)
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      point,
      userInfo,
      line,
      popup,
      showPopup
    }
  }
}
</script>

<style lang="scss" scoped>
.line-container {
  padding-top: 10px;
  background-color: #fff;
  margin-top: 16px;
  height: 230px;
}
</style>
